var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VLazyImage',{attrs:{"src":_vm.src,"src-placeholder":_vm.imgLoading()}})
}
var staticRenderFns = []

export { render, staticRenderFns }